import { Color, Spacing } from '@persona-id/design-tokens';
import styled from 'styled-components';

import { PresetInfo } from 'dashboard/forms/FormCreateGraphNode/NodeFunctionSelector';

const Column = styled.div`
  flex: 1;
`;

const Row = styled.div<{ hasDivider: boolean; isHeader: boolean }>`
  display: flex;
  padding: ${Spacing[2]};
  ${({ hasDivider }) => hasDivider && `border-bottom: 1px solid ${Color.CoreSlate100};`}
  ${({ isHeader }) => isHeader && `background-color: ${Color.BackgroundSecondary};`}
`;

interface PresetSchemaSummary {
  presetInfo: PresetInfo | undefined;
}

const PresetSchemaSummary = ({ presetInfo }: PresetSchemaSummary) => {
  if (!presetInfo) {
    return null;
  }
  return (
    <>
      <Row hasDivider={false} isHeader>
        <Column>Raw input</Column>
        <Column>Standardized output</Column>
      </Row>
      {presetInfo.examples.map((pi, idx) => (
        <Row key={idx} hasDivider={idx < presetInfo.examples.length - 1} isHeader={false}>
          <Column>{pi.rawInput}</Column>
          <Column>{pi.output}</Column>
        </Row>
      ))}
    </>
  );
};

export default PresetSchemaSummary;
